// src/pages/PaymentCancelled.jsx
import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Card } from "@mui/material";

export default function PaymentCancelled() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      window.location.href = "/pricing";
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f7fb",
        padding: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 500,
          padding: 4,
          textAlign: "center",
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          ❌ Payment Cancelled
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          It looks like the payment was cancelled. <br />
          You can try again or choose a different plan. <br />
          Redirecting to the pricing page in{" "}
          <strong>{countdown}</strong> seconds…
        </Typography>

        <Button
          variant="contained"
          color="secondary"
          size="large"
          sx={{ borderRadius: 2 }}
          onClick={() => (window.location.href = "/pricing")}
        >
          Go to Pricing Page
        </Button>
      </Card>
    </Box>
  );
}
